<template>
    <div id="Container" class="widget-container settings-widget background--card new-card-layout">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        :background-color="bg_color"
        :color="icon_color"
      ></loading>
        <template v-if="hasLoaded && !activeDialog">
            <a
                href="#"
                @click.prevent="closeSelf"
                class="close"
            >
                <svg-rndr :width="16" :height="16" svg="close.svg" />
            </a>
<!--          {{ show_billing_tab }} {{ subscriptions.show_billing_tab }}-->
            <div class="widget-contents DialogContent DialogContent--max">
                <div class="widget-contents__inner DialogContentInner card card-new">
                    <div class="card-header pb-4">
                        <div class="form-row justify-content-center">
                            <div class="col-md-auto py-3 py-lg-4">
                                <h1 class="h3">System Settings</h1>
                            </div>
                        </div>
                        <div class="form-row justify-content-center">
                            <div class="col col-md-9">
                                <div class="tabs">
                                    <a
                                        class="tab"
                                        href="#"
                                        @click.prevent="openGeneral"
                                        :class="{ active: activeTab == 'general' }"
                                        v-translate
                                    >General</a>
                                    <a
                                        class="tab"
                                        href="#"
                                        @click.prevent="openSystemSettings"
                                        :class="{ active: activeTab == 'systemsettings' }"
                                        v-translate
                                    >Trading</a>
                                    <a
                                        class="tab"
                                        href="#"
                                        @click.prevent="openMySubscriptions"
                                        :class="{ active: activeTab == 'mysubscriptions' }"
                                        v-translate
                                        v-if="isSmartCharts"
                                    >Subscriptions</a>
                                  <a
                                    v-if="subscriptions.show_billing_tab === 1"
                                    class="tab"
                                    href="#"
                                    @click.prevent="openMyBilling"
                                    :class="{ active: activeTab == 'mybilling' }"
                                    v-translate
                                  >Billing</a>
                                  <a
                                        class="tab"
                                        href="#"
                                        @click.prevent="openMyBookings"
                                        :class="{ active: activeTab == 'mybookings' }"
                                        v-translate
                                        v-if="isSmartCharts"
                                    >Bookings</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body perfect-scrollbar perfect-scrollbar--no-mobile">
                        <div
                            class="general-tab"
                            data-tab="general"
                            v-show="activeTab == 'general'">
                            <GeneralTab
                                :user="user"
                                :openPasswordResetWidget="openPasswordResetWidget"
                                :loadData="loadData"
                                :setHasLoaded="setHasLoaded"
                                transition="fade" transition-mode="out-in"
                            />
                        </div>
                        <div
                            class="subscription-tab"
                            data-tab="mysubscriptions"
                            v-show="activeTab == 'mysubscriptions'"
                            v-if="isSmartCharts">
                            <SubscriptionsTab
                                ref="subscriptionTab"
                                :hasLoaded="hasLoaded"
                                :user="user"
                                :subscriptions_data="subscriptions"
                                :activeSubscriptions="activeSubscriptions"
                                :paymentAttempts="paymentAttempts"
                                :closeBox="closeBox"
                                :cancelSubscriptions="cancelSubscriptions"
                                :loadWidgetDialog="loadWidgetDialog"
                                @changed="reloadData()"
                                transition="fade" transition-mode="out-in"
                            />
                        </div>
                        <div
                          class="system-settings-tab"
                          data-tab="mybilling"
                          v-if="isSmartCharts && subscriptions.show_billing_tab === 1"
                          v-show="activeTab == 'mybilling'">
                          <BillingTab
                            ref="billingTab"
                            :hasLoaded="hasLoaded"
                            :user="user"
                            :subscriptions_data="subscriptions"
                            :activeSubscriptions="activeSubscriptions"
                            :paymentAttempts="paymentAttempts"
                            :closeBox="closeBox"
                            :cancelSubscriptions="cancelSubscriptions"
                            :loadWidgetDialog="loadWidgetDialog"
                            @changedbilling="reloadData()"
                            transition="fade" transition-mode="out-in"/>
                        </div>
                        <div
                            class="system-settings-tab"
                            data-tab="mybookings"
                            v-if="isSmartCharts"
                            v-show="activeTab == 'mybookings'">
                            <BookingsTab
                                :user="user"
                            />
                        </div>
                        <div
                            class="system-settings-tab"
                            data-tab="systemsettings"
                            v-show="activeTab == 'systemsettings'">
                            <TradingTab />
                        </div>
                        <SettingsFooter
                            :inBody="true"
                            :activeTab="activeTab"
                            :submitHandler="submitHandler"
                            v-if="mobileLike"
                        />
                    </div>
                    <SettingsFooter
                        :inBody="false"
                        :activeTab="activeTab"
                        :submitHandler="submitHandler"
                        v-if="!mobileLike"
                    />
                </div>
            </div>
        </template>
        <div
            id="MyDialogContent"
            style="display: none"
        >
            <template v-if="hasLoaded">
                <component
                    v-for="(dialog, index) in dialogs"
                    :key="index"
                    :is="dialog"
                    v-if="activeDialog == dialog"
                    :activeSubscriptions="activeSubscriptions"
                >
                </component>
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { Maybe } from 'monet';

import TradingTab from './Tabs/Trading';
import GeneralTab from './Tabs/System';
import SubscriptionsTab from './Tabs/Subscriptions';
import BillingTab from './Tabs/Billing';
import BookingsTab from './Tabs/Bookings'

import SettingsFooter from './SettingsFooter';
import { isDesktop, mobileLike } from '@H/device_helpers';
import widgetMixin from '@M/widgets/topLevel';
import initScrollbar from '@H/addScrollbar';

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
    components: {
        TradingTab,
        GeneralTab,
        SubscriptionsTab,
        SettingsFooter,
        BillingTab,
        BookingsTab,
        Loading
    },
    mounted() {
        this.selectedUpgrade = {};
        const mql = mobileLike();
        this.mobileMatch = { ...this.mobileMatch, mql, matches: mql.matches };
        this.mobileMatch.mql.addListener(this.mobileMatchHandler);
    },
    beforeDestroy() {
        if (this.mobileMatch.hasOwnProperty('mql')) {
            this.mobileMatch.mql.removeListener(this.mobileMatchHandler);
        }
    },
    data() {
        return {
            activeTab: isSmartCharts ? 'mysubscriptions' : 'general',
            activeDialog: null,
            videoId: null,
            noAvatar: '/img/profile-default.svg',
            systemSettingsWidget: null,
            mobileMatch: {},
            show_billing_tab: 0,
            data_set: {},
            isLoading: false,
            bg_color: '#000',
            icon_color: '#fff',
            fullPage: true,
            // Anything we want to show as a smartcharts popup, we setup a vue component and add it to this array. To trigger use this.loadWidgetDialog(componentName)
            dialogs: [
                'WidgetSeeItInAction',
                'WidgetPasswordReset',
                'EditProfile',
                'UpgradeSubscription',
                'CancelSubscription',
                'UpgradeSubscriptionTeaser'
            ],
        };
    },
    watch: {
        hasLoaded(value) {
            if (!value) {
                // Reset the system settings widget - this will be removed when the page re-draws
                this.systemSettingsWidget = null;
                return;
            } else if (this.activeTab == 'systemsettings') {
                // Reloaded user settings, now reload system settings widget if it is the active tab
                this.$nextTick(() => {
                    this.openSystemSettings();
                });
            }
            if (isDesktop()) {
                this.$nextTick(() => {
                    initScrollbar();
                });
            }

            if (!isSmartCharts) {
                this.activeTab = 'general';
            }
        }
    },
    methods: {
        ...mapMutations('Widget', ['setSubscriptionUpgradeId']),
        mobileMatchHandler(m) {
            this.mobileMatch.matches = m.matches;
        },
        submitHandler(e) {
            e.preventDefault();
            const mTab = Maybe.fromNull(document.querySelector(`[data-tab="${this.activeTab}"]`));
            const tab = mTab.orSome(null);
            const mForm = Maybe.fromNull(tab.querySelector('form'));
            mForm.map(el => el.dispatchEvent(new Event('submit', { cancelable: true })));
        },
        closeBox() {
            this.selectedUpgrade.combiProductId = null;
            if (isDesktop()) {
                this.$refs.subscriptionTab.initScroll();
            }
        },
        openEditProfileWidget(e) {
            let store = this.$store;

            let eventListener = function (EV) {
                if (EV.result) {
                    // Dialog has closed - Data sent will be under the myResultData key
                    store.commit(
                        'Widget/setUser',
                        EV.result.myResultData.user
                    );
                } else if (EV.update) {
                    // Message is some kind of update from the dialog
                }
            }

            this.loadWidgetDialog('EditProfile', {
                windowWidth: 1000,
                windowHeight: '80%',
            }, {}, eventListener);
        },

        cancelSubscriptions() {
            this.loadWidgetDialog('CancelSubscription', {
                windowWidth: 1000,
                windowHeight: 550
            });
        },
        openPasswordResetWidget(e) {
            this.loadWidgetDialog('WidgetPasswordReset', {
                windowWidth: '80%',
                windowHeight: 500,
            });
        },
        openSystemSettings(e) {
            this.activeTab = 'systemsettings';

            // Only load the widget & css the one time
            if (!this.systemSettingsWidget) {
                this.systemSettingsWidget = new SC.systemsettingspage(
                    this._widgetInstance,
                    document.querySelector(".system-settings-widget")
                );
            }
        },
        openGeneral() {
            this.activeTab = 'general';
        },
        openMySubscriptions(e) {
            this.activeTab = 'mysubscriptions';
        },
        openMyBilling(e) {
          this.activeTab = 'mybilling';
        },
        openMyBookings(e) {
            this.activeTab = 'mybookings';
        },
        reloadData() {
          this.isLoading = true
          let url = "/widget/get-subscriptions";
          axios.post(url)
              .then(response => {
                // this.isLoading = false
                this.data_set = response.data
                this.$refs.subscriptionTab.reloadData(this.data_set)
                this.$refs.billingTab.reloadData(this.data_set)
                this.isLoading = false
              })
              .catch(error => {
                // this.isLoading = false
                console.log(error)
                this.isLoading = false
              })
        }
    },
    computed: {
        ...mapFields('Widget', ['selectedUpgrade']),
        ...mapState('Widget', ['paymentAttempts']),
        mobileLike() {
            return this.mobileMatch.matches;
        },
    },
    mixins: [widgetMixin]
};
</script>

<style scoped>
  .fade-transition {
    transition: opacity 0.2s ease;
  }

  .fade-enter, .fade-leave {
    opacity: 0;
  }
  .tabs .tab {
    background-color: transparent !important;
      -webkit-transition: 0.5s !important;
      transition: 0.5s !important;
  }
  .tabs .tab:active {
    background-color: rgba(158, 202, 254, 0.35) !important;
    /*background: linear-gradient(159deg, rgba(158, 202, 254, 0.15) 1%, rgba(158, 202, 254, 0.35) 100%);*/
  }
  .tabs .tab:hover {
    background-color: rgba(158, 202, 254, 0.35) !important;
    /*background: linear-gradient(159deg, rgba(158, 202, 254, 0.15) 1%, rgba(158, 202, 254, 0.35) 100%);*/
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/Settings.vue